<table cdk-table [dataSource]="tableDataService.tableDataObs$ | async" class="mat-table cdk-table mat-elevation-z8 table">
  <ng-container *ngFor="let column of tableDataService.dataColumnList$ | async" [cdkColumnDef]="column.columnDef">
    <th cdk-header-cell *cdkHeaderCellDef>{{ column.header }}</th>
    <td cdk-cell [matTooltip]="column.cell(row)" matTooltipPosition="after" *cdkCellDef="let row">
      {{ column.cell(row) }}
    </td>
  </ng-container>
  <tr cdk-header-row *cdkHeaderRowDef="tableDataService.displayedColumnsObs$ | async" class="capitalize"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: tableDataService.displayedColumnsObs$ | async"></tr>
</table>